import { render, staticRenderFns } from "./Zlxg.vue?vue&type=template&id=41b743e8&scoped=true"
import script from "./Zlxg.vue?vue&type=script&lang=js"
export * from "./Zlxg.vue?vue&type=script&lang=js"
import style0 from "./Zlxg.vue?vue&type=style&index=0&id=41b743e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b743e8",
  null
  
)

export default component.exports